export default __webpack_public_path__ + "2e9c61a844868cc86af0dadac183f19c.svg";